import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchNlpPropertiesThunk = createAsyncThunk(
  'repliersNlp/fetchProperties',
  async ({ prompt, location, nlpId }, { rejectWithValue }) => {
    try {
      const response = await axios.post('/api/nlp/v1/api/custom-nlp', {
        prompt,
        location,
        nlpId
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to process property search');
    }
  }
);
